export default {
    values: {
        'Resource Manager': 'Resource Manager',
        'Resource Manager Configuration': 'Resource Manager Configuration',
        'ALL RESOURCES': 'ALL RESOURCES',
        'New resource': 'New resource',
        'New Resource': 'New Resource',
        'Resource Code': 'Resource Code',
        Name: 'Name',
        Description: 'Description',
        Responsible: 'Responsible',
        'Resource Type': 'Resource Type',
        'Affiliated to': 'Affiliated to',
        'Nameless Res': 'Nameless Res',
        'Nameless Resource': 'Nameless Resource',
        'There are no resources yet': 'There are no resources yet',
        'Create new resource': 'Create new resource',
        Creating: 'Creating',
        Create: 'Create',
        Close: 'Close',
        Extensions: 'Extensions',
        'Descriptions or instructions': 'Descriptions or instructions',
        'Basic Info': 'Basic Info',
        Cancel: 'Cancel',
        Save: 'Save',
        Saving: 'Saving',
        'RESOURCE TYPE': 'RESOURCE TYPE',
        LOCATION: 'LOCATION',
        'Generic Resource Manager': 'Generic Resource Manager',
        'Resource Basic Informations': 'Resource Basic Informations',
        Resource: 'Resource',
        'Duplicated resource code': 'Duplicated resource code',
        'Delete resource': 'Delete resource',
        'This action cannot be undone.': 'This action cannot be undone.',
        'Features that read this list will be affected.': 'Features that read this list will be affected.',
        'If you really want to delete the resource, type': 'If you really want to delete the resource, type',
        'in the field below before completing the action:': 'in the field below before completing the action:',
        'Are you sure you want remove the resource': 'Tem certeza que quer remover o recurso',
        'Confirm deletion': 'Confirm deletion',
        'No, I do not': 'No, I do not',
        'Update Avatar': 'Update Avatar',
        'Edit Avatar': 'Edit Avatar',
        'YOU DO NOT HAVE ACCESS PERMISSION.': 'YOU DO NOT HAVE ACCESS PERMISSION.',
        'YOU DO NOT HAVE PERMISSION TO ACCESS THE RESOURCE MANAGER.':
            'YOU DO NOT HAVE PERMISSION TO ACCESS THE RESOURCE MANAGER.',
        NAME: 'NAME',
        'PRODUCT ADDED': 'PRODUCT ADDED',
        'AFFILIATED TO': 'AFFILIATED TO',
        EXTENSIONS: 'EXTENSIONS',
        RESPONSIBLE: 'RESPONSIBLE',
        'RESOURCE CODE': 'RESOURCE CODE',
        Filters: 'Filters',
        'No affiliated resources': 'No affiliated resources',
        'AFFILIATED RESOURCES': 'AFFILIATED RESOURCES',
        'Image should not exceed 1MB, accepted types are: png,jpeg and gif':
            'Image should not exceed 1MB, accepted types are: png,jpeg and gif',
        users: 'USERS',
        Users: 'Users',
        USERS: 'USERS'
    }
}
